// Palette des cravates (2026-08-14, demande utilisateur).
//
// Les ateliers utilisent des étiquettes de plusieurs couleurs : la couleur fait
// partie de l'identification du trousseau au même titre que le numéro. Cinq
// teintes seulement, reprises de la palette des tags du Planning pour ne pas
// introduire un vocabulaire chromatique de plus.
//
// La couleur du texte est FIGÉE par teinte plutôt que calculée : cinq valeurs
// connues, autant les poser une fois pour toutes — un calcul de contraste
// donnerait un gris approximatif sur le jaune.
export const COULEURS_CRAVATE = [
  { nom: 'Jaune',  fond: '#F0B429', texte: '#3B2A05' },
  { nom: 'Vert',   fond: '#10B981', texte: '#052E20' },
  { nom: 'Bleu',   fond: '#0EA5E9', texte: '#04283A' },
  { nom: 'Violet', fond: '#7C3AED', texte: '#FFFFFF' },
  { nom: 'Rouge',  fond: '#E11D48', texte: '#FFFFFF' },
];

// Jaune par défaut : c'est la couleur qu'avaient toutes les cravates avant que
// le choix existe, les dossiers déjà saisis ne changent donc pas d'aspect.
export const CRAVATE_DEFAUT = COULEURS_CRAVATE[0];

// Retrouve la teinte d'une valeur stockée. Une couleur retirée de la palette
// (ou une valeur aberrante en base) retombe sur le défaut plutôt que de casser
// l'affichage.
export const teinteCravate = (hex) =>
  COULEURS_CRAVATE.find(c => c.fond.toLowerCase() === String(hex || '').toLowerCase()) || CRAVATE_DEFAUT;
